export const LESSON_TYPE = {
  CHOICE: 'CHOICE',
  CHOICE_GRID: 'CHOICE_GRID',
  BIG_IMAGE: 'BIG_IMAGE',
  STORY: 'STORY',
}

export const LESSON_STORY_QUIZ_TYPE = {
  CHOICE: 'CHOICE_DEFAULT',
  CHOICE_GRID: 'CHOICE_GRID',
  SELECTION: 'SELECTION',
}

export const LESSON_QUESTION_COLOR = {
  [LESSON_TYPE.CHOICE]: '#00d591',
  [LESSON_TYPE.CHOICE_GRID]: '#FFA602',
  [LESSON_TYPE.BIG_IMAGE]: '#FF4A3D',
  [LESSON_TYPE.STORY]: '#9b2efd',
}

export const LESSON_AUDIO_PLAYING_STATUS = {
  PLAYING: 'PLAYING',
  STOPPED: 'STOPPED',
  PAUSED: 'PAUSED',
}
